import { render, staticRenderFns } from "./checkRecord.vue?vue&type=template&id=30d15f39"
import script from "./checkRecord.vue?vue&type=script&lang=js"
export * from "./checkRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports